import { createStrings } from '@utils/local';

export const commodityStrings = createStrings({
  ja: {
    commodity_no: '品番',
    name_en: '品名（英語）',
    name_ja: '品名（日本語）',
    url: '商品URL',
    usage: '用途',
    material: '材質',
    explanation: '商品説明',
    memo: 'メモ',
    images: '商品画像',
    hs_code: 'HS code',
    d2dStaffFill: 'D2D担当者記入欄',
    maxImages: '最大６枚までお願いします',
  },
} as const);
